var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._b({attrs:{"input-value":_vm.isChecked,"label":_vm.label,"dense":"","hide-details":""},on:{"change":_vm.toggle}},'v-checkbox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }